import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { head } from 'lodash';
import { FlexContainer, Panel } from '@pitchero/react-ui';
import NetworkPanelHeader from './header';
import AdminList from './admin-list';
import ClubAccountList from './club-account-list';
import MainNetworkPanelMenu from './main-menu';
import SuperUserMenu from './super-user-menu';

const NetworkPanel = ({
  badgeTotals,
  clubs,
  competitions,
  isOpen,
  leagueWebsites,
  onClose,
  settingsUrl,
  user,
}) => {
  const [currentView, setView] = useState('main_menu');

  const clubAdminCount = clubs.filter((club) => club.isAdmin).length;
  const leagueAdminCount = leagueWebsites.filter((league) => league.isAdmin).length;
  const competitionAdminCount = competitions.length;
  const totalAdminCount = clubAdminCount + leagueAdminCount + competitionAdminCount;

  const onClickAccountHandler = () => {
    if (clubs.length === 1) {
      window.location = `/token-redirect?url=${clubs[0].accountUrl}`;
    } else {
      setView('account');
    }
  };

  const onClickAdminDashboard = () => {
    if (totalAdminCount > 1) {
      setView('admin');
    } else if (clubAdminCount === 1) {
      window.location = `/token-redirect?url=${
        head(clubs.filter((club) => club.isAdmin)).adminUrl
      }`;
    } else if (leagueAdminCount === 1) {
      window.location = `/token-redirect?url=${
        head(leagueWebsites.filter((league) => league.isAdmin)).adminUrl
      }`;
    } else {
      window.location = `/token-redirect?url=${head(competitions).adminUrl}`;
    }
  };

  const renderContent = () => {
    if (currentView === 'admin') {
      return (
        <AdminList
          clubs={clubs.filter((club) => club.isAdmin)}
          leagueWebsites={leagueWebsites.filter((league) => league.isAdmin)}
          competitions={competitions}
          onClickBack={() => setView('main_menu')}
        />
      );
    }

    if (currentView === 'account') {
      return (
        <ClubAccountList
          clubs={clubs}
          badgeTotals={badgeTotals}
          onClickBack={() => setView('main_menu')}
        />
      );
    }
    return (
      <>
        <MainNetworkPanelMenu
          adminCount={totalAdminCount}
          badgeTotals={badgeTotals}
          clubs={clubs}
          leagueWebsites={leagueWebsites}
          onClickAccount={onClickAccountHandler}
          onClickAdminDashboard={onClickAdminDashboard}
          settingsUrl={settingsUrl}
        />
        {user.isSuperUser && <SuperUserMenu />}
      </>
    );
  };

  return (
    <Panel isOpen={isOpen} onClose={onClose}>
      <FlexContainer flexDirection="column" style={{ height: '100%' }}>
        <NetworkPanelHeader user={user} />
        {renderContent()}
      </FlexContainer>
    </Panel>
  );
};

NetworkPanel.propTypes = {
  badgeTotals: PropTypes.shape().isRequired,
  clubs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  competitions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  leagueWebsites: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  settingsUrl: PropTypes.string.isRequired,
  user: PropTypes.shape().isRequired,
};

export default NetworkPanel;
